module.exports = __webpack_public_path__ + "static/img/img_logo3.8f57af4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_pc/img_logo3.png
// module id = D6Kh
// module chunks = 0